import { Component, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SnackBarService } from '@cbuild/controls';
import { FormStateControl } from '@cbuild/shared';
import { take } from 'rxjs';
import { ModuleTypeEnum } from 'src/app/account-settings/communication-settings/communication-grid/moduleType.enum';
import { CallCenterService } from '../../call-center.service';
import { TemplateData, TemplateTypes } from '../../models/template-types-model';

@Component({
  selector: 'cs-whatsapp-communication',
  standalone: false,
  templateUrl: './whatsapp-communication.component.html',
  styleUrls: ['./whatsapp-communication.component.scss']
})
export class WhatsappCommunicationComponent extends FormStateControl
  implements OnInit {
  @Input()
  public form: FormGroup;
  public templateTypes: Array<TemplateTypes> | undefined;
  public moduleTypeEnum = ModuleTypeEnum;
  public isLoading: boolean;
  public templateData: TemplateData;

  constructor(
    private fb: FormBuilder,
    private service: CallCenterService,
    private renderer: Renderer2,
    private el: ElementRef,
    private snackbar: SnackBarService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.service
      .getWhatsappTemplates(this.moduleTypeEnum.SALES)
      .pipe(take(1))
      .subscribe(res => {
        this.templateTypes = res;
      });
    const group = this.form.get('whatsappCommunication');
    if (!group) {
      this.infoForm = this.initializeInfoForm();
      this.form.addControl('whatsappCommunication', this.infoForm);
    } else {
      this.infoForm = this.form.get('whatsappCommunication') as FormGroup;
      this.onTemplateChange(null);
    }
  }

  private initializeInfoForm(): FormGroup {
    return this.fb.group({
      templateType: [],
      templateTypeId: [],
      isOtherTemplate: [],
      moduleType: this.moduleTypeEnum.SALES
    });
  }

  public onTemplateChange(selectedText?: string | null): void {
    const selectedTemplate = this.templateTypes?.find(
      x => x.label === selectedText
    );
    const templateTypeValue = selectedTemplate?.value ?? this.getControl('templateTypeId').value;
    const isOtherTemplate =
      (selectedTemplate?.isOtherTemplate ?? this.templateTypes?.find(x => x.value === templateTypeValue)?.isOtherTemplate) == true ? true : false;
    const propertyId = this.form.get('propertyId')?.value;
    this.getControl('isOtherTemplate').setValue(
      isOtherTemplate
    );

    if (propertyId) {
      this.service
        .getWhatsappTemplateData(
          propertyId,
          templateTypeValue,
          isOtherTemplate
        )
        .pipe(take(1))
        .subscribe(res => {
          this.isLoading = true;
          const templateType = isOtherTemplate === false ? res.templateTypeId : res.templateId;
          this.getControl('templateType').setValue(templateType);
          this.templateData = res;
          this.loadPreview();
        });
    } else {
      this.getControl('templateTypeId').setValue(null);
      this.snackbar.open('Please select property', {
        type: 'error'
      });
    }
  }

  private loadPreview(): void {
    this.isLoading = true;
    const element = this.el.nativeElement.querySelector('.parent div span');
    this.renderer.setProperty(
      element,
      'innerHTML',
      this.templateData.previewMessage
    );
    this.isLoading = false;
  }
}
